import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { sortIcons } from 'helpers/icon_helpers';
import {
  peopleInformationMappings,
  sortableColumnTypes,
  defaultColumnMappings,
  excludedColumns
} from './people_constants';

import TableHeader from 'components/table_header/table_header';
import PeopleColumnSelector from './column_selector';
import { hideOverlayFilters, showOverlayFilters } from '../store/actions/ui';

export class PeopleTableHeader extends React.Component {
  static propTypes = {
    allowSort: PropTypes.bool,
    currentColumns: PropTypes.array.isRequired,
    hideOverlayFilters: PropTypes.func.isRequired,
    includeSearchResults: PropTypes.bool,
    showColumnFilters: PropTypes.bool,
    showOverlayFilters: PropTypes.func.isRequired,
    sort: PropTypes.string,
    onSortChange: PropTypes.func
  };

  static defaultProps = {
    allowSort: true
  };

  activeSort() {
    const { sort } = this.props;

    if (sort == null) {
      return { field: null, direction: null };
    }

    const [field, direction] = sort.split(' ');
    return { field, direction };
  }

  renderNameHeader() {
    const { allowSort, onSortChange } = this.props;
    if (!allowSort) return <th><span name="name-header">Name</span></th>;

    const { field: sortedField, direction: sortedDirection } = this.activeSort();
    const iconSet = sortIcons.alpha;
    let icon = sortIcons.sort;

    if (sortedField === 'first_name' || sortedField === 'last_name') {
      icon = iconSet[sortedDirection];
    }

    return (
      <th>
        <Dropdown
          id="sort-by-name-dropdown"
          name="sort-by-name-dropdown"
          onSelect={sortOption => onSortChange(sortOption)}
        >
          <span name="name-header">Name</span>
          <span bsRole="toggle">
            <FontAwesomeIcon
              className="left-buffer-md clickable"
              icon={icon}
              name="sortable-name-icon"
            />
          </span>

          <Dropdown.Menu>
            <MenuItem header>Sort by Name</MenuItem>
            <MenuItem eventKey='first_name asc'>
              {this.renderIconLabel('First Name', iconSet.asc)}
            </MenuItem>
            <MenuItem eventKey='first_name desc'>
              {this.renderIconLabel('First Name', iconSet.desc)}
            </MenuItem>
            <MenuItem eventKey='last_name asc'>
              {this.renderIconLabel('Last Name', iconSet.asc)}
            </MenuItem>
            <MenuItem eventKey='last_name desc'>
              {this.renderIconLabel('Last Name', iconSet.desc)}
            </MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </th>
    );
  }

  renderIconLabel(label, icon) {
    return (
      <React.Fragment>
        {label}
        <FontAwesomeIcon className="left-buffer-md" icon={icon} />
      </React.Fragment>
    );
  }

  render() {
    return (
      <TableHeader
        {...this.props}
        customHeaders={{
          name: this.renderNameHeader()
        }}
        defaultColumnMappings={defaultColumnMappings}
        excludedColumns={excludedColumns}
        informationMappings={peopleInformationMappings}
        sortableColumnTypes={sortableColumnTypes}
      >
        <PeopleColumnSelector onCancelColumns={this.props.hideOverlayFilters} />
      </TableHeader>
    );
  }
}

const mapStateToProps = state => ({
  currentColumns: state.session.currentColumns,
  showColumnFilters: state.ui.showColumnFilters
});

const mapDispatchToProps = {
  hideOverlayFilters,
  showOverlayFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleTableHeader);
